exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3185250503/src/src/app/common/print/print/print.component.scss
// module id = ../../../../../src/app/common/print/print/print.component.scss
// module chunks = main